// extracted by mini-css-extract-plugin
export default {"sm":"sm-hGp4I","md":"md-l1fvC","lg":"lg-n3gzu"};